import React from 'react';
import { Button, Modal } from 'antd';
import GenerateCampaignModalContent from './GenerateCampaignModalContent';
import { FormProvider, useForm } from 'react-hook-form';
import _ from 'lodash';
import { useGenerateCampaign } from '../../../../mutation/acg/phase-1';

export default function GenerateCampaignButton() {
  const [visible, setVisible] = React.useState(false);
  const form = useForm({
    defaultValues: {
      routineName: '',
      routineArguments: {},
    },
    reValidateMode: 'onBlur',
    resolver: async data => {
      const errors = {};
      if (!data.routineName) {
        errors.routineName = 'Routine name is required';
      }
      Object.entries(data.routineArguments).forEach(([key, value]) => {
        if (value === null) {
          errors[`routineArguments.${key}`] = `Argument ${key} is required`;
        }
      });
      if (!_.isEmpty(errors)) {
        return {
          values: {},
          errors,
        };
      }
      return {
        values: data,
        errors,
      };
    },
  });
  const { isValid } = form.formState;
  const { mutateAsync, isLoading } = useGenerateCampaign();
  return (
    <FormProvider {...form}>
      <Button icon="plus" onClick={() => setVisible(true)}>
        Generate Campaign
      </Button>
      <Modal
        okButtonProps={{
          loading: isLoading,
          onClick: form.handleSubmit(async data => {
            await mutateAsync(data).catch(() => {});
            setVisible(false);
          }),
          disabled: !isValid,
        }}
        title="Generate Campaign"
        visible={visible}
        width={800}
        onCancel={() => setVisible(false)}
      >
        <GenerateCampaignModalContent />
      </Modal>
    </FormProvider>
  );
}
